import { get } from 'lodash';
import getImageUrl from '../../services/get-image-url';

export const getImageMetadataFromWixMedia = image => ({
  src: get(image, 'file_name') ? getImageUrl(image) : null,
  height: get(image, 'height', null),
  width: get(image, 'width', null),
});

export const getVideoThumbnailMetadata = videoMetadata => ({
  src: get(videoMetadata, 'thumbnail_url', null),
  height: get(videoMetadata, 'height', null),
  width: get(videoMetadata, 'width', null),
});
